// ----------------------------------------------------------------------

// const account = {
//   displayName: 'Jaydon Frankie',
//   email: 'demo@minimals.cc',
//   photoURL: '/assets/images/avatars/avatar_default.jpg',
// };

// export default account;


import React from 'react'
import { useSelector } from 'react-redux'

const useAccount = () => {

  const {mashawiriuser} = useSelector(state => state.auth)

  const account = {
    displayName: mashawiriuser.first_name,
    email: mashawiriuser.phone,
    photoURL: `${process.env.REACT_APP_API_URL_IMAGE}${mashawiriuser.image}`
  }


  return {account}


}

export default useAccount
